<template>
  <section class="mt-12" v-if="showingDestinationFilter">
    <h4 class="fs-20 font-medium mb-4">Destinations</h4>

    <template v-if="destination.type === 'country'">
      <template v-for="province in destination.children">

        <checkbox :key="province.id"
          v-model="options.destinationOptions[`opt${province.id}`]"
          :partial="isPartialSelected(province.id)"
          @input="handleProvinceChanged(province.id)"
          @change="$emit('filter-changed')">
          <div class="font-medium" v-html="province.name"></div>
        </checkbox>

        <template v-for="destination in province.children">

          <checkbox :key="destination.slug"
            class="ml-4"
            v-show="isDestinationVisible(destination.id)"
            v-model="options.destinationOptions[`opt${destination.id}`]"
            @input="handleDestinationChanged(province.id)"
            @change="$emit('filter-changed')">
            <div v-html="destination.name"></div>
          </checkbox>

        </template>
      </template>
    </template>
    <template v-else-if="destination.type === 'province'">
      <template v-for="destination in destination.children">

        <checkbox :key="destination.slug"
          v-model="options.destinationOptions[`opt${destination.id}`]"
          v-show="isDestinationVisible(destination.id)"
          @change="$emit('filter-changed')">
          <div v-html="destination.name"></div>
        </checkbox>

      </template>
    </template>
  </section>
</template>

<script>
import get from 'lodash/get'
import { mapState } from 'vuex'
import Checkbox from '../../core/Checkbox'

export default {
  components: {
    Checkbox
  },
  computed: {
    ...mapState(['destination', 'statistics']),
    showingDestinationFilter () {
      return this.destination.type !== 'destination'
    }
  },
  inject: ['options'],
  methods: {
    isPartialSelected (provinceId) {
      const { destination } = this.$store.state
      const province = destination.children.find(prov => String(prov.id) === String(provinceId))

      if (province.children.every(dest => this.options.destinationOptions[`opt${dest.id}`])) {
        return false
      }

      return province.children.some(dest => this.options.destinationOptions[`opt${dest.id}`])
    },
    handleProvinceChanged (provinceId) {
      const { destination } = this.$store.state
      const province = destination.children.find(prov => String(prov.id) === String(provinceId))

      for (const dest of province.children) {
        if (this.options.destinationOptions[`opt${provinceId}`]) {
          this.options.destinationOptions[`opt${dest.id}`] = true
        }
        else {
          this.options.destinationOptions[`opt${dest.id}`] = false
        }
      }
    },
    handleDestinationChanged (provinceId) {
      const { destination } = this.$store.state
      const province = destination.children.find(prov => String(prov.id) === String(provinceId))

      if (province.children.every(dest => !this.options.destinationOptions[`opt${dest.id}`])) {
        this.options.destinationOptions[`opt${provinceId}`] = false
      }
    },
    isDestinationVisible (destinationId) {
      return get(this.statistics, ['visibleDestinations', destinationId], false) === true
    }
  }
}
</script>